import { render, staticRenderFns } from "./PopupSingle.vue?vue&type=template&id=78a4c72c&scoped=true&lang=pug"
import script from "./PopupSingle.vue?vue&type=script&lang=js"
export * from "./PopupSingle.vue?vue&type=script&lang=js"
import style0 from "./PopupSingle.vue?vue&type=style&index=0&id=78a4c72c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a4c72c",
  null
  
)

export default component.exports